import React from 'react';
import { useForm } from 'react-final-form';
import { Icon } from 'js/components/common/Icon';
import { useFieldName } from 'js/components/common/Fields/withField';

import style from './index.scss';

export const ValidationIcon = ({
    className = '',
    isValid,
    animate = false,
    onClick,
    ...props // data attributes
}) => {
    const name = useFieldName();
    const { resetFieldState } = useForm();
    const resetOnClick = () => resetFieldState(name);
    const iconOnClick = onClick ?? resetOnClick;

    return (
        <Icon
            className={`${style.icon} ${className} ${animate ? 'showBounceIn' : ''}`}
            type={isValid ? 'formFieldValid' : 'formFieldInvalid'}
            onClick={iconOnClick}
            {...props}
        />
    );
};

export default ValidationIcon;
